module.exports = __webpack_public_path__ + "img/twitter.72f17cb4.svg";